import React from 'react';
import { useTranslation } from 'react-i18next';

import LeftContent from '../components/LeftContent';
import RightContent from '../components/RightContent';

const Home: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className="u-login u-restrict-md ">
      <div className="u-heading pt8 pb8">
        <h1 className="h-xl-bold">{t('loginSection.title')}</h1>
      </div>

      <div className="u-row u-center-content">
        {/* Left part */}
        <LeftContent />

        {/* Right part */}
        <RightContent />
      </div>


    </section>
  );
};

export default Home;
